import { useTranslation } from "../../../../i18n/useTranslation";

const LegalPage = ({ title, sections }) => {
  const { t } = useTranslation();
  return (
    <div>
      <div className="band-hero section-tight text-center">
        <div className="eyebrow">{t("legalPage.eyebrow")}</div>
        <h1 className="text-3xl md:text-4xl">{title}</h1>
      </div>
      <div className="band-a section-tight text-left">
        <div className="max-w-3xl mx-auto flex flex-col gap-6 px-5">
          {sections.map((s) => (
            <div key={s.heading}>
              <h4>{s.heading}</h4>
              <p className="mini">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LegalPage;
